import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from '../auth/LoginPage';
import OtpVerifyPage from '../auth/OtpVerifyPage';
import ForgotPasswordPage from '../auth/ForgotPasswordPage';
import { RequireAuth } from './RequireAuth';
import { RequireRole } from './RequireRole';
import { AppLayout } from '../layout/AppLayout';
import DashboardPage from '../pages/dashboard/DashboardPage';
import { registeredModules } from './modules';

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-otp" element={<OtpVerifyPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          {registeredModules
            .flatMap((m) => m.routes)
            .map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  route.requiresRole ? (
                    <RequireRole check={route.requiresRole}>{route.element}</RequireRole>
                  ) : (
                    route.element
                  )
                }
              />
            ))}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
